/**
 * @generated SignedSource<<ed92b0636bc91c11fc97e5de6784c620>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ArchiveClientAssetInput = {
  projectId: string;
  assetId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type clientAssetMutationsArchiveMutation$variables = {
  input: ArchiveClientAssetInput;
};
export type clientAssetMutationsArchiveMutation$data = {
  readonly archiveClientAsset: {
    readonly asset: {
      readonly id: string;
      readonly status: string;
      readonly archived: boolean;
    } | null;
  } | null;
};
export type clientAssetMutationsArchiveMutation = {
  variables: clientAssetMutationsArchiveMutation$variables;
  response: clientAssetMutationsArchiveMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ArchiveClientAssetPayload",
    "kind": "LinkedField",
    "name": "archiveClientAsset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ClientAsset",
        "kind": "LinkedField",
        "name": "asset",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "archived",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "clientAssetMutationsArchiveMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "clientAssetMutationsArchiveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f6c02a4b89239da48f0f2de56d4d41a8",
    "id": null,
    "metadata": {},
    "name": "clientAssetMutationsArchiveMutation",
    "operationKind": "mutation",
    "text": "mutation clientAssetMutationsArchiveMutation(\n  $input: ArchiveClientAssetInput!\n) {\n  archiveClientAsset(input: $input) {\n    asset {\n      id\n      status\n      archived\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1433be937b55a03d3b95b151898909e2";

export default node;
